const closeButton = document.querySelector('.js-popup-close');

if (closeButton) {
  closeButton.addEventListener('click', () => {
    const popup = closeButton.closest('.popup')
    popup.remove()
  })
}
